import { useEffect, useState } from 'react';
import { Text } from '@chakra-ui/react';

import { CustomHeading } from 'shared-components';

import QuestionPage from '../../../templates/question';
import Checkbox from '../../../molecules/checkboxQuestion';
import { Q } from '../../../../store/student/types';
import { OptionStatusType } from 'types';
import { useCustomNavigate } from '../../../../hooks/useCustomNavigate';
import { useDispatch } from 'react-redux';
import { saveConsents } from '../../../../store/student/actions';
import { Pages } from '../../../../store/student/consents/types';

export interface IProps {
  sectionTitle: string;
  currentStep: number;
  steps: number;
  consent?: boolean;
  config: any;
  configVisaSupport: OptionStatusType;
  visaSupportLocked?: boolean;
}

export interface IDispatchProps {
  onNext: (config: any) => void;
  onBackToTaskList: () => void;
}

type Props = IProps & IDispatchProps;

function ConsentsQPage3(props: Props) {
  const [consent, setConsent] = useState(props.consent || false);
  const isMandatory =
    [OptionStatusType.MANDATORY_DIRECT, OptionStatusType.MANDATORY_ALL].includes(props.configVisaSupport) ||
    props.visaSupportLocked;

  const dispatch = useDispatch();
  const onNext = (config: any) => dispatch(saveConsents(Pages.PAGE3, config));

  const { navigateToStudentDashboard } = useCustomNavigate();
  const onBackToTaskList = () => navigateToStudentDashboard();

  useEffect(() => {
    setConsent(props.consent || false);
  }, [props.consent, setConsent]);

  return (
    <QuestionPage
      complete={consent}
      currentStep={props.currentStep}
      steps={props.steps}
      onNext={() => onNext(props.config)}
      onBackToTaskList={onBackToTaskList}
      section={props.sectionTitle}
    >
      <CustomHeading level={'h2'}>{props.config.Page3.heading}</CustomHeading>

      <Text
        fontSize={'lg'}
        dangerouslySetInnerHTML={{
          __html: isMandatory ? props.config.Page3.blurbMandatory : props.config.Page3.blurb,
        }}
      />

      <Checkbox
        key={Q.CONSENTS_3}
        id={Q.CONSENTS_3}
        isTicked={consent}
        checkboxLabel={'I agree'}
        onChange={(_key: string, isTicked: boolean) => setConsent(isTicked)}
      />
    </QuestionPage>
  );
}

export default ConsentsQPage3;
